<div class="container">
  <div class="wrapper" *ngIf="!error">
    <div class="title-section">
      <ion-text class="title ion-text-start">Cambio de vía de pago de pensión</ion-text>
      <ion-text class="label ion-text-start">
        Solicita que tu pensión sea pagada en tu cuenta bancaria y evita trámites presenciales
      </ion-text>
    </div>
    <div class="item-container">
      <div class="item-container-icon">
        <img src="../assets/icons/dinero.svg" slot="start" class="item-icono-svg" alt="">
      </div>
      <div class="item-text">
        <ion-text class="text-header"> Solicita el pago de la pensión en tu cuenta bancaria </ion-text>
        <ion-text class="text-description">
          Si recibes tu pensión desde Servipag o Caja Los Héroes, solicita que sea depositada en tu cuenta bancaria
        </ion-text>
      </div>
    </div>

    <div class="item-container">
      <div class="item-container-icon">
        <img src="../assets/icons/listado.svg" slot="start" class="item-icono-svg" alt="">
      </div>
      <div class="item-text">
        <ion-text class="text-header"> Ingresa una cuenta unipersonal y a tu nombre </ion-text>
      </div>
    </div>
    <div class="item-container">
      <div class="item-container-icon">
        <img src="../assets/icons/check.svg" slot="start" class="item-icono-svg" alt="">
      </div>
      <div class="item-text">
        <ion-text class="text-header"> Validaremos tu solicitud y depositaremos tu pensión </ion-text>
        <ion-text class="text-description">
          Nos comunicaremos contigo en caso de ser necesario. <br>Una vez confirmada tu solicitud, el cambio se realizará al mes siguiente
        </ion-text>
      </div>
    </div>
    <button
      class="b-btn p-button primary-button" (click)="iniciarCambioViaPago()" [disabled]="loading">
      Solicitar
      <div class="spinner-wrapper">
        <ion-spinner
          name="crescent"
          slot="end"
          *ngIf="loading"
          color="light"
        ></ion-spinner>
      </div>
    </button>
  </div>
  <div *ngIf="error">
      
    <app-generic-error class="wrapper" 
      *ngIf="error"
      [ops]="errorOps"
      [enableButtonRetry]="enableButtonRetry"
      (retryEvent)="onRetryEvent()"
      (goToEvent)="onGoToEvent()">
    </app-generic-error>
  
  </div>
</div>
